import Nullstack from 'nullstack';
export default function IconFall({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-fall",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M6 16l-1 -4l3 -4"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "5",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 12h2.5l4 2"
  }), " ");
}